import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import axios from "../../../library/axios";
import { Button, Dropdown, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { IconEdit, IconTrash, IconZoomIn } from "@tabler/icons-react";
import ListDokumentEp from "./list-dokumen";
import ActionButton from "../../../helpers/countDocument";
import ActionButtonUploadFile from "../../../helpers/buttonActionUploadFile";
import UploadDokumen from "./upload";
import { getSlug, } from "../../../../src/config/routes/guards/slug";

const DatatableManagerFile = (props) => {
  const [element, setElement] = useState([]);
  const [dokumen, setDokumen] = useState([]);
  const [show, setShow] = useState(false);
  const [showUpload, setShowUpload] = useState(false);
  const [idVariable, setIdVariable] = useState([]);
  const [role, setRole] = useState("");

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleCloseUpload = () => setShowUpload(false);
  const handleShowUpload = () => setShowUpload(true);
  const [count, setCount] = useState([]);

  const fetchLoginStatus = async () => {
    try {
      const options = {
        url: `/users/detailUser`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);

      setRole(data?.data?.mapping_user_groups[0]?.group?.namaGroup);
    } catch (err) {
      console.log(err.message);
    }
  };

  const handleElemen = async (value) => {
    // console.log('ini id variable', value)
    try {
      const options = {
        url: `/chapters/listDocumentByIdVariable/${value}`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data);
      setDokumen(data);
    } catch (err) {
      console.log(err.message);
    }
  };

  const handleIdVariable = async (value) => {
    setIdVariable(value);
  };
  // console.log(role)
  useEffect(() => {
    fetchLoginStatus();
  }, []);

  const columns = [
    {
      name: "Aksi",
      width: "130px",
      cell: (row) => (
        <>
          {role == "Surveior Internal" ? (
            <>
              <ActionButton
                row={row}
                handleElemen={handleElemen}
                handleShow={handleShow}
              />
              <ActionButtonUploadFile
                row={row.id}
                handleIdVariable={handleIdVariable}
                handleShowUpload={handleShowUpload}
              />
            </>
          ) : (
            ""
          )}
          {role == "Administrator" ? (
            <>
              <ActionButton
                row={row}
                handleElemen={handleElemen}
                handleShow={handleShow}
              />
              <ActionButtonUploadFile
                row={row.id}
                handleIdVariable={handleIdVariable}
                handleShowUpload={handleShowUpload}
              />
            </>
          ) : (
            ""
          )}
          {role == "Kelompok Kerja" ? (
            <>
              <ActionButton
                row={row}
                handleElemen={handleElemen}
                handleShow={handleShow}
              />
              <ActionButtonUploadFile
                row={row.id}
                handleIdVariable={handleIdVariable}
                handleShowUpload={handleShowUpload}
              />
            </>
          ) : (
            ""
          )}
          {role == "Surveior External" ? (
            <ActionButton
              row={row}
              handleElemen={handleElemen}
              handleShow={handleShow}
            />
          ) : (
            ""
          )}
        </>
      ),
    },
    {
      name: "Standar",
      width: "85px",
      cell: (row) => row.elements_accreditation.Nomor,
    },
    {
      name: "Abjad",
      width: "65px",
      cell: (row) => row.Abjad,
    },
    {
      name: "Deskripsi",
      width: "600px",
      cell: (row) => row.Deskripsi,
    },
  ];

  return (
    <>
      <DataTable
        columns={columns}
        data={props?.data}
        pagination
        fixedHeader
        highlightOnHover
        subHeader
      // subHeaderComponent={
      //     <input
      //         type="text"
      //         // placeholder="Search Item PPS"
      //         className="w-50 form-control m-3"
      //         values={props.search}
      //         onChange={(e) => props.handleChangeSearch(e.target.value)}
      //     />  const [show, setShow] = useState(false);
      // }
      // subHeaderAlign="center"
      />

      <Modal
        show={show}
        onHide={handleClose}
        size="xl"
        dialogClassName="modal-290w"
        aria-labelledby="example-custom-modal-styling-title"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Dokumen EP</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ListDokumentEp data={dokumen} handleClose={handleClose} />
        </Modal.Body>
      </Modal>

      <Modal
        show={showUpload}
        onHide={handleCloseUpload}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Upload Dokumen EP</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <UploadDokumen
            id={idVariable}
            handleCloseUpload={handleCloseUpload}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DatatableManagerFile;
